import { create } from 'zustand';
let toastIdCounter = 0;
const createToastId = () => {
    toastIdCounter += 1;
    return `toast-${toastIdCounter}`;
};
export const useToastStore = create((set) => ({
    toasts: [],
    pendingToasts: [],
    showToast: (message) => set((state) => ({
        toasts: [
            ...state.toasts,
            {
                id: createToastId(),
                message,
            },
        ],
    })),
    hideToast: (id) => set((state) => ({
        toasts: state.toasts.filter((toast) => toast.id !== id),
    })),
    enqueuePendingToast: (message) => set((state) => {
        if (state.pendingToasts.includes(message)) {
            return state;
        }
        return {
            pendingToasts: [...state.pendingToasts, message],
        };
    }),
    flushPendingToasts: () => {
        let pendingToasts = [];
        set((state) => {
            pendingToasts = state.pendingToasts;
            return { pendingToasts: [] };
        });
        return pendingToasts;
    },
}));
